import { ParentOption, PickerOption } from '../store/schema/CompositePickerInterfaces';
import CompositePickerStore from '../store/schema/CompositePickerStore';
import { action } from 'satcheljs';

export const expandParentOption = action(
    'expandParentOption',
    (viewState: CompositePickerStore, parentOption: ParentOption, parentIsExpanded: boolean) => ({
        viewState,
        parentOption,
        parentIsExpanded,
    })
);

export const updateParentOptionIsExpanded = action(
    'updateParentOptionIsExpanded',
    (viewState: CompositePickerStore, parentOption: ParentOption, parentIsExpanded: boolean) => ({
        viewState,
        parentOption,
        parentIsExpanded,
    })
);

export const updateChildOptionIsShown = action(
    'updateChildOptionIsShown',
    (viewState: CompositePickerStore, pickerOption: PickerOption, optionIsShown: boolean) => ({
        viewState,
        pickerOption,
        optionIsShown,
    })
);
